import { useQueryClient } from "@tanstack/react-query"

import { useGetBookingHash } from "modules/Call/routing"
import { Call, GET_CALL_QUERY_KEY } from "modules/Call/queries"
import { processError } from "modules/Call/common/utils/processError"

export function useHandleError(error?: Error) {
    const queryClient = useQueryClient()

    const bookingHash = useGetBookingHash()

    const call = queryClient.getQueryData<Call>([GET_CALL_QUERY_KEY, bookingHash])

    if (error) {
        throw processError(error, call)
    }
}
